<template>
  <component v-if="address.street || address.postal_code || address.country" :is="address.link ? 'a' : 'div'" :href="address.link" :target="address.link ? '_blank' : null" :class="{'hover:text-(--accent-color) transition-[color]': address.link}">
    <span v-if="address.street" class="block">{{ `${address.street},` }}</span>
    <span v-if="address.postal_code" class="block">{{ `${address.locality ? address.locality + ', ' : '' } ${address.region ? address.region + ', ' : ''} ${address.postal_code}` }}</span>
    <span v-if="address.country" class="block">{{ `${address.country}` }}</span>
  </component>
</template>

<script lang="ts">
import type {PropType} from "vue";

export default {
  name: 'Address',
  props: {
    address: {
      type: Object as PropType<Address>,
      required: true
    }
  }
}
</script>